import MenuTabs from './menu-tabs';

class JelloChild {
  /**
   * Sets necessary variables for this class
   * that are used throughout
   */
  constructor() {
    this.menuTabs = new MenuTabs();
    JelloChild.experiencesSlider();

    $('.main > .container > .hero, .main > .container > .vc_row:first-of-type.hero-col, .main > .hero-wrap')
      .parents('body')
      .addClass('has-hero');

    $(`.main > .container > .hero:not(.text-dark),
      .main > .container > .vc_row.color-white:first-child.hero-col,
      .main > .container > .vc_row.text-white:first-child .hero-col,
      .main > .hero-wrap.text-white`)
      .parents('body')
      .addClass('has-hero-dark');
    
    $('.dropdown-toggle').on('keypress', (e) => {
      const isSpace = e.keyCode === 32;

      if (!isSpace) {
        return;
      }

      if (document.activeElement !== e.currentTarget) {
        return;
      }

      e.preventDefault();
      $(e.currentTarget).dropdown('toggle');
    });
  }

  static experiencesSlider() {
    const slider = document.querySelector('.experiences.owl-carousel');

    if (slider && global.Jello.createSlider) {
      global.Jello.createSlider(slider, {
        items: 1,
        margin: 15,
        loop: true,
        autoHeight: true,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 4500,
      });
    }
  }
}

$(() => {
  /* eslint-disable no-new */
  new JelloChild();
  /* eslint-enable no-new */
});
